import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Features, UserRole } from "../../Enums/companyStatus";
import { hasPermission, hasRole } from "../../Helpers/authHelpers";

type Props = {
  features: Features[];
  fallbackPath?: string;
};

const RequireAnyFeature: React.FC<Props> = ({
  features,
  fallbackPath = "/home",
}) => {
  if (hasRole(UserRole.ADMIN) || features.some(hasPermission)) {
    return <Outlet />;
  }

  return <Navigate to={fallbackPath} replace />;
};

export default RequireAnyFeature;
